import React from 'react'
import { makeStyles } from '@mui/styles';


const ModalPrivacy = (props) => {

    const { name, about } = props

    const useStyles = makeStyles({
        containerItem: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%'
        },
        title: {
            color: '#055c9d',
            margin: 0,
        },
        text: {
            color: '#333333',
            fontSize: '22px',
            marginTop: 10
        }
    })

    const classes = useStyles()

    return (
        <div className={classes.containerItem}>
            <h1 className={classes.title}>{name}</h1>
            <p className={classes.text}>{about}</p>
        </div>
    )
}

export default ModalPrivacy